import { render, staticRenderFns } from "./SellerManageList.vue?vue&type=template&id=c13522b4&scoped=true&"
import script from "./SellerManageList.vue?vue&type=script&lang=js&"
export * from "./SellerManageList.vue?vue&type=script&lang=js&"
import style0 from "./SellerManageList.vue?vue&type=style&index=0&id=c13522b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13522b4",
  null
  
)

export default component.exports